export interface IWhereConditions {
	condition: "and" | "or",
	rules: IConditionRule[]
}

export interface IConditionRule {
	operator: "equal" | "equalElementById" | "isNotEmpty"
	field: string;
	value: string;
}

export class ArrayWhereFilter {

	where: IWhereConditions;

	public filter(rows: any[], where: IWhereConditions | undefined): any[] {
		if (!where) {
			return rows;
		}
		this.where = where;

		return rows.filter(x => this.filterRow(x))
	}
	 

	private filterRow(row: any): boolean {

		for (const rule of this.where.rules) {
			const isOk = this.isOk(rule, row);
			if (!isOk && this.where.condition === 'and') {
				return false;
			}
			if (isOk && this.where.condition === 'or') {
				return true;
			}
		}

		return this.where.condition === 'and';
	}

	private isOk(condition: IConditionRule, row: any): boolean {
		switch (condition.operator) {
			case "equalElementById":
				return this.isEqualElementById(condition, row);
			case "isNotEmpty":
				return this.isNotEmpty(condition, row);
			case "equal":
			default:
				return this.isEqual(condition, row);
		}
	};

	private isEqual(condition: IConditionRule, row: any): boolean {
		return (row[condition.field] ?? "").toLowerCase() === condition.value.toLowerCase();
	}

	private isNotEmpty(condition: IConditionRule, row: any): boolean {
		return (row[condition.field] ?? "").trim() !== "";
	}

	private isEqualElementById(condition: IConditionRule, row: any): boolean {
		
		const element = document.getElementById(condition.value);
		let strValue = '';
		if (element) {
			if (element.tagName.toLocaleLowerCase() === 'input') {
				strValue = (element as HTMLInputElement).value;
			} else {
				strValue = element.innerText;
			}
		}

		return (row[condition.field] ?? '').toLowerCase() === strValue.toLowerCase();
	}
}